// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__2BxH2","selects":"Documents_selects__37GJ1"};